import { NoParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/configuration'

interface Endpoints {
  getConfig: NoParamEndpointConstructor
  updateConfig: NoParamEndpointConstructor
}

export const configEndpoints: Endpoints = {
  getConfig: () => `${baseUrl}`,
  updateConfig: () => `${baseUrl}`,
}
